module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 1v4d
// module chunks = 3